<div class="flex flex-col gap-5 p-4 pb-[calc(2rem+env(safe-area-inset-bottom))]">
    @if (step === 1) {
        <!-- Étape 1 : la zone (réutilise vw-user-adress-location-form) -->
        <div class="flex items-center gap-2 text-xs font-semibold text-[#317756]">
            <span class="h-1.5 w-1.5 rounded-full bg-[#317756]"></span>
            {{ 'garden.zone-wizard.progress1' | translate }}
        </div>
        <vw-user-adress-location-form [location]="null" (closeLocationForm)="onZoneCreated($event)"></vw-user-adress-location-form>
    } @else {
        @if (!showAddBedSheet) {
            <!-- Étape 2 : les planches -->
            <div class="flex flex-col gap-4">
                <div class="flex items-center gap-2 text-xs font-semibold text-[#317756]">
                    <span class="h-1.5 w-1.5 rounded-full bg-[#317756]"></span>
                    {{ 'garden.zone-wizard.progress2' | translate }}
                </div>
                <h2 class="text-[#062825] text-xl font-semibold">
                    {{ 'garden.zone-wizard.created-title' | translate: { name: createdLocation?.name } }}
                </h2>
                <p class="text-sm text-[#545F5A]">{{ 'garden.zone-wizard.beds-intro' | translate }}</p>

                <div class="flex flex-col gap-2">
                    @for (bed of addedBeds; track $index) {
                        <div class="flex items-center gap-3 rounded-2xl border border-[#DFE2E1] bg-white p-3">
                            <span class="text-xl">{{ bed.type === 'POT' ? '🪴' : '🔲' }}</span>
                            <div class="min-w-0 flex-1">
                                <p class="truncate text-sm font-semibold text-[#062825]">{{ bed.name }}</p>
                                <p class="text-xs text-[#9BA6A1]">
                                    @if (bed.type === 'POT') {
                                        {{ bed.capacity }} {{ 'garden.zone-wizard.pot-capacity' | translate }}
                                    } @else {
                                        {{ bed.rows }} × {{ bed.columns }}
                                    }
                                </p>
                            </div>
                        </div>
                    } @empty {
                        <p class="rounded-2xl bg-gray-50 p-4 text-center text-sm text-[#9BA6A1]">{{ 'garden.zone-wizard.empty' | translate }}</p>
                    }
                </div>

                <button type="button" (click)="openAddBed()"
                    class="w-full rounded-full border-[1.5px] border-[#317756] py-3 text-sm font-semibold text-[#317756]">
                    + {{ 'garden.zone-wizard.add-bed' | translate }}
                </button>

                <button type="button" (click)="finish()"
                    class="w-full rounded-full bg-primary py-3 text-sm font-semibold text-white hover:bg-black transition">
                    {{ 'garden.zone-wizard.finish' | translate }}
                </button>
                <button type="button" (click)="finish()" class="text-center text-sm text-[#9BA6A1] underline">
                    {{ 'garden.zone-wizard.later' | translate }}
                </button>
            </div>
        } @else {
            <!-- Sous-feuille : ajouter une planche (réutilise vw-garden-bed-create inline) -->
            <button type="button" (click)="closeAddBed()" class="flex items-center gap-1 text-sm font-medium text-[#317756]">
                ← {{ 'garden.zone-wizard.back-to-beds' | translate }}
            </button>
            <vw-garden-bed-create [locationUid]="createdLocation.uid" [autoNavigate]="false"
                (bedCreated)="onBedCreated($event)"></vw-garden-bed-create>
        }
    }
</div>
